// extracted by mini-css-extract-plugin
export default {"wrap":"modal_wrap__HY6t-","back":"modal_back__fj4qF","content":"modal_content__DDC4P"};